import { typographyTokens } from '../../theme/typographyTokens';
import React, { useState } from 'react';
import Departments from './Departments';
import KnockoutScreens from './KnockoutScreen';
import Tasks from './Tasks';
import { DataFields } from './DataFields';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import { useAccount } from '@azure/msal-react';
import { useNavigate } from 'react-router';
import { env } from '../../../shared/env';
import { SEPApplication } from './SEPApplication';
import Others from './Others/Others';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: string;
  currentSubTab: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, currentSubTab, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== currentSubTab}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === currentSubTab && <Box sx={{ px: 0 }}>{children}</Box>}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const StyledTab = styled((props: any) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    font: 'normal normal normal 16px/22px Open Sans;',
    height: '48px !important',
    minHeight: '48px',
    padding: '10px 10px 10px 0px',
    width: '100%',
    alignSelf: 'start',
    '&:hover': {
      color: '#2372B9',
    },
    '&.MuiTab-root': {
      textAlign: 'right',
      justifyContent: 'left ! important',
      paddingLeft: '30px',
      maxWidth:'220px'
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.blue.lightBlue1,
      color: '#2372B9',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  })
);

const Admin = () => {
  const [currentSubTab, setCurrentSubTab] =
    useState<string>('Knockout Screens');

  const handleSubTabChange = (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    setCurrentSubTab(newValue);
  };
  const theme = useTheme();
  const account = useAccount();

  const roleList: any = React.useMemo(() => {
    if (env.REACT_APP_LOCAL_DEV_ADMIN === 'true') {
      return ['AuthSuperUser'];
    } else {
      return account?.idTokenClaims?.roles || [];
    }
  }, [account]);

  const isSuperUser =
    roleList?.includes('AuthSuperUser') &&
    (process.env.NODE_ENV === 'test'
      ? process.env.REACT_APP_SHOW_ADMIN_FEATURES === 'true'
      : env.REACT_APP_SHOW_ADMIN_FEATURES === 'true');
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isSuperUser) {
      navigate('/');
    }
  }, [isSuperUser, navigate]);
  return (
    <>
      <Box
        display="flex"
        sx={{
          bgcolor: 'background.paper',
          flexDirection:'column',
          //overflowY: 'auto',
        }}
      >
        <Box
          sx={{
            paddingBottom:'15px',
            width: '100%',
            position:'sticky',
            top:0,
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.white.main,
            zIndex:9,

          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{
              paddingLeft: '30px',
              paddingTop: '30px',
              paddingBottom: '10px',
              fontWeight: typographyTokens.fontWeights.medium,
              fontSize: typographyTokens.fontSizes.h5Small,
              minWidth: 200,
              textAlign:'center',
              borderBottom:'1px solid lightgray',
              marginBottom:'10px'
            }}
          >
            Admin Control Panel
          </Typography>
          <Tabs
            // orientation="vertical"
            // variant="scrollable"
            centered
            value={currentSubTab}
            onChange={handleSubTabChange}
            aria-label="Vertical tabs"
            sx={{
              minWidth: 200,
              '& .MuiTabs-flexContainer': {
                flexDirection: 'row',
                //justifyContent: 'flex-start',
              },
              //textALign: 'left',
            }}
            TabIndicatorProps={{
              style: { backgroundColor: theme.palette.blue.lightBlue1 },
            }}
          >
            <StyledTab
              value="Knockout Screens"
              icon={<i className="fa-solid fa-window"></i>}
              iconPosition="start"
              label="Knockout Screens"
              {...a11yProps(0)}
              onClick={() => setCurrentSubTab('Knockout Screens')}
            />
            <StyledTab
              value="Tasks"
              icon={<i className="fa-regular fa-list-check"></i>}
              iconPosition="start"
              label="Tasks"
              {...a11yProps(1)}
              onClick={() => setCurrentSubTab('Tasks')}
            />
            <StyledTab
              value="Data Fields"
              icon={<i className="fa-solid fa-pen-field"></i>}
              iconPosition="start"
              label="Data Fields"
              {...a11yProps(2)}
              onClick={() => setCurrentSubTab('Data Fields')}
            />
            <StyledTab
              value="Departments"
              icon={<i className="fa-solid fa-users"></i>}
              iconPosition="start"
              label="Departments"
              {...a11yProps(3)}
              onClick={() => setCurrentSubTab('Departments')}
            />
            <StyledTab
              value="SEP Application"
              icon={<CorporateFareIcon />}
              iconPosition="start"
              label="SEP Application"
              {...a11yProps(4)}
              onClick={() => setCurrentSubTab('SEP Application')}
            />
            <StyledTab
              value="Others"
              icon={<FormatListBulletedIcon />}
              iconPosition="start"
              label="Others"
              {...a11yProps(4)}
              onClick={() => setCurrentSubTab('Others')}
            />
          </Tabs>
        </Box>
        <Box sx={{ flexGrow: 1, flexBasis: 'auto', width: '100%', marginTop:'2px' }}>
          <TabPanel
            value="Knockout Screens"
            currentSubTab={currentSubTab}
            index={0}
          >
            <KnockoutScreens />
          </TabPanel>
          <TabPanel value="Tasks" currentSubTab={currentSubTab} index={1}>
            <Tasks />
          </TabPanel>
          <TabPanel value="Data Fields" currentSubTab={currentSubTab} index={2}>
            <DataFields />
          </TabPanel>
          <TabPanel value="Departments" currentSubTab={currentSubTab} index={3}>
            <Departments />
          </TabPanel>
          <TabPanel
            value="SEP Application"
            currentSubTab={currentSubTab}
            index={4}
          >
            <SEPApplication />
          </TabPanel>
          <TabPanel value="Others" currentSubTab={currentSubTab} index={5}>
            <Others />
          </TabPanel>
        </Box>
      </Box>
    </>
  );
};

export default Admin;
